var map = {
	"./front/ico-calculator": "./app/assets/images/front/ico-calculator.svg",
	"./front/ico-calculator.svg": "./app/assets/images/front/ico-calculator.svg",
	"./front/ico-checkbox-check": "./app/assets/images/front/ico-checkbox-check.svg",
	"./front/ico-checkbox-check.svg": "./app/assets/images/front/ico-checkbox-check.svg",
	"./front/ico-dropdown": "./app/assets/images/front/ico-dropdown.svg",
	"./front/ico-dropdown.svg": "./app/assets/images/front/ico-dropdown.svg",
	"./front/ico-email": "./app/assets/images/front/ico-email.svg",
	"./front/ico-email.svg": "./app/assets/images/front/ico-email.svg",
	"./front/ico-pdf": "./app/assets/images/front/ico-pdf.svg",
	"./front/ico-pdf.svg": "./app/assets/images/front/ico-pdf.svg",
	"./front/ico-rate-checkbox-check": "./app/assets/images/front/ico-rate-checkbox-check.svg",
	"./front/ico-rate-checkbox-check.svg": "./app/assets/images/front/ico-rate-checkbox-check.svg",
	"./ico-chevron-down": "./app/assets/images/ico-chevron-down.svg",
	"./ico-chevron-down.svg": "./app/assets/images/ico-chevron-down.svg",
	"./ico-circle-minus": "./app/assets/images/ico-circle-minus.svg",
	"./ico-circle-minus.svg": "./app/assets/images/ico-circle-minus.svg",
	"./ico-circle-plus": "./app/assets/images/ico-circle-plus.svg",
	"./ico-circle-plus.svg": "./app/assets/images/ico-circle-plus.svg",
	"./ico-circle-times-teal": "./app/assets/images/ico-circle-times-teal.svg",
	"./ico-circle-times-teal.svg": "./app/assets/images/ico-circle-times-teal.svg",
	"./ico-delete": "./app/assets/images/ico-delete.svg",
	"./ico-delete.svg": "./app/assets/images/ico-delete.svg",
	"./ico-duplicate": "./app/assets/images/ico-duplicate.svg",
	"./ico-duplicate.svg": "./app/assets/images/ico-duplicate.svg",
	"./ico-export": "./app/assets/images/ico-export.svg",
	"./ico-export.svg": "./app/assets/images/ico-export.svg",
	"./ico-eye": "./app/assets/images/ico-eye.svg",
	"./ico-eye.svg": "./app/assets/images/ico-eye.svg",
	"./ico-menu-close": "./app/assets/images/ico-menu-close.svg",
	"./ico-menu-close.svg": "./app/assets/images/ico-menu-close.svg",
	"./ico-menu-collapsed": "./app/assets/images/ico-menu-collapsed.svg",
	"./ico-menu-collapsed.svg": "./app/assets/images/ico-menu-collapsed.svg",
	"./ico-new-rate": "./app/assets/images/ico-new-rate.svg",
	"./ico-new-rate.svg": "./app/assets/images/ico-new-rate.svg",
	"./ico-pdf": "./app/assets/images/ico-pdf.svg",
	"./ico-pdf.svg": "./app/assets/images/ico-pdf.svg",
	"./ico-pencil": "./app/assets/images/ico-pencil.svg",
	"./ico-pencil.svg": "./app/assets/images/ico-pencil.svg",
	"./ico-plus-orange": "./app/assets/images/ico-plus-orange.svg",
	"./ico-plus-orange.svg": "./app/assets/images/ico-plus-orange.svg",
	"./ico-save": "./app/assets/images/ico-save.svg",
	"./ico-save.svg": "./app/assets/images/ico-save.svg",
	"./logo": "./app/assets/images/logo.svg",
	"./logo.svg": "./app/assets/images/logo.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/assets/images sync recursive ^\\.\\/.*$";